import { Flex, VStack } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { RowData } from '../../../components/tables/base/MasterTable'
import SkillTable from '../../../components/tables/SkillTable'
import JobTable from '../../../components/tables/JobTable'
import RolesTable from '../../../components/tables/RolesTable'
import AccountabilityAreasTable from '../../../components/tables/AccountabilityAreasTable'
import { jobData } from '../../../data/jobData'
import { skillData } from '../../../data/skillData'

interface ClassificationPageProps {
  selectedTab: string
}

const ClassificationPage: React.FC<ClassificationPageProps> = ({ selectedTab }) => {
  const [jobProfiles, setJobProfiles] = useState<RowData[]>([])
  const [skills, setSkills] = useState<RowData[]>([])
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    setJobProfiles(jobData)
    setSkills(skillData)
  }, [])

  const renderTable = () => {
    switch (selectedTab) {
      case 'jobprofile':
        return <JobTable data={jobProfiles} setData={setJobProfiles} />
      case 'skills':
        return <SkillTable data={skills} setData={setSkills} />
      case 'roles':
        return <RolesTable />
      case 'accountability':
        return <AccountabilityAreasTable />
      default:
        return null
    }
  }

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%">
        {renderTable()}
      </VStack>
    </Flex>
  )
}

export default ClassificationPage
